<section class="community-youtube">
    <div class="container">
        <!-- Header Section -->
        <div class="youtube-header">
            <div class="header-content">
                <h1 class="page-title">
                    <i class="fab fa-youtube"></i>
                    Hawker Channels
                </h1>
                <p class="page-description">
                    Let's learn more from YouTube!
                </p>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading videos...</p>
            </div>
        </div>

        <!-- YouTube Videos Grid -->
        <div class="youtube-grid" *ngIf="!isLoading && youtubeList.length > 0">
            <div class="youtube-card" *ngFor="let video of youtubeList; trackBy: trackById"
                (click)="openVideoModal(video.youtubeUrl)">
                <div class="video-thumbnail">
                    <img [src]="getYouTubeThumbnail(video.youtubeUrl)" [alt]="'YouTube Video ' + video.id"
                        (error)="$event.target.src='assets/images/default-video.jpg'" class="thumbnail-image" />
                    <div class="play-button">
                        <i class="fas fa-play"></i>
                    </div>
                    <div class="video-overlay"></div>
                </div>

                <div class="video-info">
                    <div class="video-meta">
                        <span class="video-date">
                            <i class="far fa-calendar"></i>
                            {{ video.createdAt | date:'MMM dd, yyyy' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!isLoading && youtubeList.length === 0">
            <div class="empty-content">
                <i class="fab fa-youtube"></i>
                <h3>No Videos Found</h3>
                <p>No YouTube videos are available at the moment. Check back later for new content!</p>
            </div>
        </div>

        <!-- Load More Button -->
        <div class="load-more-container" *ngIf="!isLoading && hasMoreItems && youtubeList.length > 0">
            <button class="load-more-btn" (click)="loadMore()" [disabled]="isLoadingMore"
                [class.loading]="isLoadingMore">
                <span *ngIf="!isLoadingMore">
                    <i class="fas fa-plus"></i>
                    Load More Videos
                </span>
                <span *ngIf="isLoadingMore">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                </span>
            </button>
        </div>

        <!-- Loading More Items -->
        <div class="loading-more" *ngIf="isLoadingMore">
            <div class="loading-more-content">
                <i class="fas fa-spinner fa-spin"></i>
                <p>Loading more videos...</p>
            </div>
        </div>
    </div>
</section>